import {
    Component,
    Injectable,
    EventEmitter,
    Inject,
    Output,
    Input,
    NgModule,
    ViewChild
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DewService } from "../services/dew.service";
import { MainService } from "../services/main.services";
import { ApiService } from "../services/api.services";
import * as _ from "lodash";
import { Config } from "../config";
import { config } from "rxjs";
import { query } from "@angular/animations";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DewAuthService } from "src/authentication/core/auth.service";

declare const fabric: any;

@Component({
    selector: "imageView",
    templateUrl: "ImageView.component.html",
    styleUrls: []
})
export class imageViewerDialogComponent {
    
    Image;
    ImageName;
    url;
    constructor(
        private dialogRef: MatDialogRef<imageViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private route: Router,
        private dewService: DewService,
        private mainService: MainService,
        private authService: DewAuthService,
        private api: ApiService,
        private snackBar: MatSnackBar
        //private docservice: DocumentService,

    ) {
        this.url = Config.DocumentBaseUrl;
        this.Image = this.url + data.docUrl;
        this.ImageName = data.documentName;
    }

    ngOnInit() {
        // console.log('Start App');
        // this.docservice.getDocument('hello');
        // this.getQueryString();
    }

    goToLink(Image: string){
        window.open(Image, "_blank");
    }

    closeImagePopup() {
        this.dialogRef.close();
    }








    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
    }
}
